module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/fish-right-icon-e5c7b6825306e929f6ecbf7b30a3eafa.svg";